interface CapabilitiesHeroProps {
  onOpenDrawer: () => void;
}

export default function CapabilitiesHero({ onOpenDrawer }: CapabilitiesHeroProps) {
  return (
    <section className="relative pt-[72px] overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/57caa573131127832f61b7728e558a8f.jpg"
          alt="background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/70 via-white/60 to-white/90"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 py-24 text-center">
        <div className="inline-flex items-center gap-2 bg-[#14B8A6]/10 border border-[#14B8A6]/20 rounded-full px-4 py-1.5 mb-6">
          <span className="w-2 h-2 rounded-full bg-[#14B8A6] inline-block"></span>
          <span className="text-sm text-[#0D9488] font-medium">产品与价格</span>
        </div>

        <h1 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
          AI驱动的出口合规管理平台
        </h1>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed mb-10">
          以结构化数据归集与规则校验为核心，<br />
          构建可解释、可追溯、可复盘的出口业务合规管理体系。
        </p>

        <div className="flex items-center justify-center gap-4">
          <button
            onClick={() => {
              const el = document.getElementById('plan-cards');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="h-12 px-8 bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] text-white text-sm font-semibold rounded-full hover:scale-105 transition-transform whitespace-nowrap cursor-pointer shadow-lg shadow-orange-200"
          >
            查看订阅方案
          </button>
          <button
            onClick={() => {
              const scenariosEl = document.getElementById('scenarios-link');
              if (scenariosEl) {
                window.REACT_APP_NAVIGATE('/scenarios');
              }
            }}
            className="h-12 px-8 border border-gray-300 text-gray-700 text-sm font-medium rounded-full hover:border-[#14B8A6] hover:text-[#14B8A6] transition-colors whitespace-nowrap cursor-pointer"
          >
            查看场景方案
          </button>
        </div>

        <div className="mt-6">
          <button
            onClick={() => {
              const el = document.getElementById('a-class');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="text-[#14B8A6] text-sm font-medium hover:underline transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-1 mx-auto"
          >
            先跑通一票（9.9/99）
            <i className="ri-arrow-right-up-line text-base"></i>
          </button>
        </div>
      </div>
    </section>
  );
}